import React from 'react';
import { useWallet } from '../../context/WalletContext';

import { FaWallet, FaBell, FaSignOutAlt, FaBars } from 'react-icons/fa';
import logo from '../../assets/logo.png';

const Topbar = ({ mobileOpen, setMobileOpen }) => {
  const { isAdmin, connectWallet, isConnected, loading, disconnectWallet } = useWallet();

  // Removed unused shortenAddress function since it's not being used
  // If you need to display the address, you can add it back and use it

    return (
      <header className="topbar w-full bg-gradient-to-br from-white to-gray-100 dark:from-gray-950 dark:to-gray-900 border-b border-gray-200 dark:border-gray-800 shadow-sm flex items-center justify-between px-2 sm:px-4 py-2 sm:py-3 sticky top-0 z-40">
        {/* Left Section - Logo & Mobile Menu Button */}
        <div className="flex items-center gap-2">
          {/* Mobile Menu Button (only shown on mobile) */}
          <button 
            className="md:hidden p-2 rounded-md bg-gray-100 dark:bg-gray-800 hover:bg-cyan-100 dark:hover:bg-cyan-900 border border-gray-200 dark:border-gray-700 transition-all"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Open menu"
          >
            <FaBars className="w-5 h-5 text-cyan-700 dark:text-cyan-200" />
          </button>
          {/* Logo/Brand */}
          <img src={logo} alt="Dolphin Logo" className="w-7 h-7 sm:w-8 sm:h-8 object-contain mr-1" />
          <span className="font-bold text-base sm:text-lg tracking-tight text-cyan-700 dark:text-cyan-200">DOLPHIN</span>
          {isAdmin && (
            <span className="ml-2 px-2 py-0.5 rounded bg-purple-100 dark:bg-purple-900 text-xs font-semibold text-purple-700 dark:text-purple-200">Admin</span>
          )}
        </div>
        {/* Right Section - Wallet Info */}
        <div className="flex items-center gap-2 sm:gap-4">
          {isConnected ? (
            <>
              {/* Notifications - Hidden on mobile */}
              <button className="hidden md:flex items-center justify-center p-2 rounded-md bg-gray-100 dark:bg-gray-800 hover:bg-cyan-100 dark:hover:bg-cyan-900 border border-gray-200 dark:border-gray-700 transition-all relative" title="Notifications">
                <FaBell className="w-5 h-5 text-cyan-700 dark:text-cyan-200" />
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold rounded-full px-1.5 py-0.5">2</span>
              </button>
              {/* Wallet Info */}
              <div className="flex items-center gap-1 px-2 py-1 rounded bg-cyan-50 dark:bg-cyan-900/30 border border-cyan-100 dark:border-cyan-700">
                <span className="w-2 h-2 bg-cyan-400 rounded-full inline-block mr-1"></span>
                <span className="text-xs text-cyan-700 dark:text-cyan-200 font-medium hidden sm:inline">Polygon</span>
              </div>
              {/* Logout Button */}
              <button
                className="flex items-center gap-1 px-2 py-1 rounded-md bg-red-100 dark:bg-red-900 hover:bg-red-200 dark:hover:bg-red-800 border border-red-200 dark:border-red-700 text-red-700 dark:text-red-200 font-semibold text-xs sm:text-sm transition-all"
                onClick={disconnectWallet}
                title="Disconnect"
              >
                <FaSignOutAlt className="w-4 h-4" />
                <span className="hidden lg:inline ml-1">Disconnect</span>
              </button>
            </>
          ) : (
            <button 
              className="flex items-center gap-1 px-3 py-1 rounded-md bg-cyan-500 hover:bg-cyan-600 text-white text-xs sm:text-sm font-semibold transition-all shadow"
              onClick={connectWallet}
              disabled={loading}
            >
              {loading ? (
                <span className="spinner w-4 h-4 border-2 border-white border-t-cyan-500 rounded-full animate-spin" />
              ) : (
                <>
                  <FaWallet className="w-4 h-4 mr-1" /> 
                  <span className="hidden sm:inline">Connect Wallet</span>
                  <span className="sm:hidden">Connect</span>
                </>
              )}
            </button>
          )}
        </div>
      </header>
    );
}

export default Topbar;